import { render, staticRenderFns } from "./agentKvConfig.vue?vue&type=template&id=126318e8"
import script from "./agentKvConfig.vue?vue&type=script&lang=js"
export * from "./agentKvConfig.vue?vue&type=script&lang=js"
import style0 from "./agentKvConfig.vue?vue&type=style&index=0&id=126318e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports